import { Radio as AntdRadio } from 'antd';
import styled, { css } from 'styled-components';

const PorscheRadioCss = css`
    & .ant-radio {
        margin-bottom: 6px;
    }

    &.ant-radio-wrapper {
        display: flex;
        align-items: center;

        & > span {
            font-size: var(--button-font-size, 1rem);
            font-weight: 100;
        }
    }

    & .ant-radio-inner {
        border-color: rgb(98, 102, 105);
        width: 1.75rem;
        height: 1.75rem;
    }

    & .ant-radio:hover .ant-radio-inner,
    .ant-radio-input:focus + .ant-radio-inner {
        box-shadow: none;
        border-color: #000;
    }

    & .ant-radio-inner::after {
        background-color: rgb(50, 54, 57);
        width: 1.5rem;
        height: 1.5rem;
        margin-top: -0.75rem;
        margin-left: -0.75rem;
    }

    & .ant-radio-checked .ant-radio-inner::after {
        transform: scale(0.8);
    }

    & .ant-radio-checked::after {
        border-color: rgb(98, 102, 105);
        background-color: rgb(50, 54, 57);
    }
`;

const Radio = styled(AntdRadio)`
    ${PorscheRadioCss}
`;

export default Radio;
